import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Dropdown from 'react-dropdown';

import { Root, Label, GlobalStyle } from './styles';

class DropFilter extends PureComponent {
  render() {
    const { label, items, handleChange, value } = this.props;

    return (
      <Root>
        <GlobalStyle />
        <Label>{label} :</Label>
        <Dropdown
          options={items}
          onChange={object => handleChange(object)}
          value={value}
          placeholder={'Chargement...'}
        />
      </Root>
    );
  }
}

DropFilter.propTypes = {
  label: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  handleChange: PropTypes.func.isRequired,
  value: PropTypes.string
};

export default DropFilter;
